import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from '../../../common/containers/ApplicationContext';
import { SeoMarkedListContainer } from '../../../common/containers/SeoMarkedList/SeoMarkedListContainer';
import {
  selectIsDesktopListingAvailable,
  selectIsDesktopListingVisible,
} from '../../../common/selectors/desktopListing';
import { FooterAdfoxBanner } from '../FooterAdfoxBanner';
import { JournalHighlightsContainer } from '../JournalHighlightsContainer';
import { RealtorRequestTrapContainer } from '../RealtorRequestTrapContainer';
import { SeoCrossLinksContainer } from '../SeoCrossLinks';
import * as styles from './FooterContainer.css';

export function FooterContainer() {
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const isDesktopListingAvailable = useSelector(selectIsDesktopListingAvailable);
  const isDesktopListingVisible = useSelector(selectIsDesktopListingVisible);
  const isSeoEnabled = config.get<boolean>('dailyrent.seo.Enabled');

  if (!isDesktop || !isDesktopListingAvailable || !isDesktopListingVisible) {
    return null;
  }

  return (
    <div className={styles['root']}>
      <RealtorRequestTrapContainer />
      <FooterAdfoxBanner />
      {isSeoEnabled && <JournalHighlightsContainer />}
      {isSeoEnabled && <SeoCrossLinksContainer />}
      {isSeoEnabled && <SeoMarkedListContainer />}
    </div>
  );
}
